import React from "react";
import { Box, Typography } from "@bca/ui-library";
import KeyDecisionInfoContainer from "./KeyDecisionInfoContainer";
import { IVehicleDetailsModule } from "../common/analytics/analytics.types";
import analytics from "../common/analytics/analytics";
import { IProductPushable } from "../common/analytics/analytics.types";
import Grade1SVG from "../icons/ConditionReportIcons/Grade1SVG";
import GradeUnknownSVG from "../icons/ConditionReportIcons/GradeUnknownSVG";
import Grade2SVG from "../icons/ConditionReportIcons/Grade2SVG";
import Grade3SVG from "../icons/ConditionReportIcons/Grade3SVG";
import Grade4SVG from "../icons/ConditionReportIcons/Grade4SVG";
import Grade5SVG from "../icons/ConditionReportIcons/Grade5SVG";
import GradeRetailReadySVG from "../icons/ConditionReportIcons/GradeRetailReadySVG";
import GradeUnclassifiedSVG from "../icons/ConditionReportIcons/GradeUnclassifiedSVG";

const gradeIcon = {
  unknown: {
    icon: <GradeUnknownSVG />,
    label: "Unknown",
  },
  "1": {
    icon: <Grade1SVG />,
    label: "Grade 1",
  },
  "2": {
    icon: <Grade2SVG />,
    label: "Grade 2",
  },
  "3": {
    icon: <Grade3SVG />,
    label: "Grade 3",
  },
  "4": {
    icon: <Grade4SVG />,
    label: "Grade 4",
  },
  "5": {
    icon: <Grade5SVG />,
    label: "Grade 5",
  },
  "retail ready": {
    icon: <GradeRetailReadySVG />,
    label: "Retail Ready",
  },
  unclassified: {
    icon: <GradeUnclassifiedSVG />,
    label: "Unclassified",
  },
};

const pushConditionReportAnalytics = (
  vehicleAnalytics: IVehicleDetailsModule
) => {
  analytics.push<IProductPushable>({
    event: {
      name: "click",
      category: "button",
      label: "condition-report",
      action: "download",
      type: "pdf",
      section: "card",
    },
    product: {
      vehicle: [vehicleAnalytics],
    },
  });
};

const ConditionReport: React.FunctionComponent<{
  grade?: string;
  anchorLink?: string;
  vehicleAnalytics?: IVehicleDetailsModule;
  viewport?: string;
}> = ({ grade = "Unknown", anchorLink, vehicleAnalytics, viewport }) => {
  const onConditionClick = (event) => {
    if (!anchorLink) {
      return;
    }

    event.stopPropagation();
    pushConditionReportAnalytics(vehicleAnalytics);

    window.open(anchorLink, "_blank");
  };

  return (
    <KeyDecisionInfoContainer
      onClick={onConditionClick}
      viewport={viewport}
      anchorLink={anchorLink}
    >
      {viewport !== "mobile" ? (
        <>
          <Box
            display="flex"
            alignItems="baseline"
            justifyContent="space-between"
            width="100%"
          >
            <Typography
              variant="body-small"
              fontWeight="medium"
              m={0}
              color="footer-blue"
            >
              Condition
            </Typography>
          </Box>
          {(grade || grade === "0") && (
            <Box
              data-testid="condition-report-icon"
              ml={0}
              mb={0}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {gradeIcon[grade.toLowerCase()].icon}
            </Box>
          )}
        </>
      ) : (
        <Box
          display="flex"
          alignItems="baseline"
          justifyContent="space-between"
          width="100%"
        >
          <Box width="100%" display="flex" alignItems="center">
            {gradeIcon[grade.toLowerCase()].icon}
            <Typography variant="body-small" m={0} ml={2} fontWeight="medium">
              {gradeIcon[grade.toLowerCase()].label}
            </Typography>
          </Box>
        </Box>
      )}
    </KeyDecisionInfoContainer>
  );
};

export default ConditionReport;
